<template>
  <v-card class="pa-7 clickable" :to="`/packet/${packet.packetId}`" :disabled="testPacket(packet)">
    <v-layout row wrap>
      <v-flex xs12 sm6 md6 lg3 xl2>
        <h3><v-icon>$satelliteDark</v-icon> {{ getSatName(packet) }} </h3>
        <div>{{ `${dateFormat(packet.serverTime)} (${dateSince(packet.serverTime)})` }}</div>
      </v-flex>
      <v-flex xs6 sm3 md3 lg2 xl1>
        <div class="caption grey--text align-center justify-center">Mode</div>
        <div class="text-center">{{ `${packet.mode}@${packet.freq}` }}</div>
      </v-flex>
      <v-flex xs6 sm4 md2 lg1 xl1>
        <div class="caption grey--text text-center">📻 Power</div>
        <div class="text-center">
          {{ packet.parsed && packet.parsed.payload && packet.parsed.payload.tinygsTxPower ? packet.parsed.payload.tinygsTxPower.toFixed(0) + "mW" : "- -" }}
        </div>
      </v-flex>
      <v-flex xs6 sm4 md2 lg1 xl1>
        <div class="caption grey--text text-center">📏 Distance</div>
        <div class="text-center">
          {{ packet.station.distance ? packet.station.distance.toFixed(0) + "Km" : "- -" }}
        </div>
      </v-flex>
      <v-flex xs6 sm4 md2 lg1 xl1>
        <div class="caption grey--text text-center">📐 Elevation</div>
        <div class="text-center">
          {{ packet.station.elevation ? packet.station.elevation.toFixed(2) + "º" : "- -" }}
        </div>
      </v-flex>
      <v-flex xs6 sm4 md2 lg1 xl1>
        <div class="caption grey--text text-center">📶 RSSI</div>
        <div class="text-center ">{{ packet.station.receptionParams.rssi }} dBm</div>
      </v-flex>
      <v-flex xs6 sm4 md3 lg1 xl1>
        <div class="caption grey--text text-center">SNR</div>
        <div class="text-center">{{ packet.station.receptionParams.snr }} dB</div>
      </v-flex>
      <v-flex xs6 sm4 md2 lg2 xl1>
        <div class="caption grey--text text-center">Doppler Server / tGS.</div>
        <div class="text-center">
          {{ packet.station.doppler ? packet.station.doppler.toFixed(0) + " " : "- - " }} /
          {{ packet.station.f_doppler ? packet.station.f_doppler.toFixed(0) + " Hz" : " - - Hz" }}
        </div>
      </v-flex>
      <v-flex xs6 sm4 md4 lg2 xl1>
        <div class="caption grey--text text-center">Freq. Error / tGS offset</div>
        <div class="text-center">
          {{ packet.station.receptionParams.frequency_error ? packet.station.receptionParams.frequency_error.toFixed(0) : "- -" }}
          /
          {{ packet.station.frequency_offset ? packet.station.frequency_offset.toFixed(0) + " Hz" : "- - Hz" }}
        </div>
      </v-flex>
      <v-flex xs6 sm4 md4 lg1 xl1>
        <div class="caption grey--text text-center">CRC Error</div>
        <div class="text-center">
          <v-icon color="red">{{ packet.station.crc_error ? "mdi-checkbox-blank-circle" : "" }}</v-icon>
        </div>
      </v-flex>
      <v-flex xs6 sm4 md2 lg1 xl1>
        <div class="caption grey--text text-center">Received by</div>
        <div class="text-center">
          {{ packet.stationNumber ? packet.stationNumber + " Stations" : "- -" }}
        </div>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script setup>
import moment from 'moment'

const { packet } = defineProps({
  packet: {
    type: Object,
    required: true
  }
})

function dateFormat(time) {
  return moment(time).format("ll HH:mm:ss")
}

function dateSince(time) {
  return moment(time).fromNow()
}

function getSatName(packet) {
  if (packet.raw && packet.raw.startsWith("VGlueUdTLXRlc3Q"))
    return "TinyGS Test Packet"

  if (!packet.parsed)
    return "Unknown"

  if (typeof packet.satPos === 'undefined')
    return `${packet.satDisplayName} ... 🤔 TLE ❌`

  return `${packet.satDisplayName} ${packet.sunLit ? " ☀️" : " 🌜"}`
}

function testPacket(packet) {
  if (packet.raw && packet.raw.startsWith("VGlueUdTLXRlc3Q"))
    return true
  return false
}
</script>

<style>
</style>